export const socketEvents = {
  bookingNew: "restaurant:booking:new",
  bookingModified: "restaurant:booking:modified",
  bookingCancelled: "restaurant:booking:cancelled",
  notificationNew: "restaurant:notification:new",
} as const;
